import commonPhoneScams from './articles/common-phone-scams';
import redFlags from './articles/red-flags';
import whatNotToDo from './articles/what-not-to-do';
import verifyBeforeYouTrust from './articles/verify-before-you-trust';
import callerIdSpoofing from './articles/caller-id-spoofing';
import smishing from './articles/smishing';
import understandingCallerIdAustralia from './articles/understanding-caller-id-australia';
import traceUnknownPhoneNumber from './articles/trace-unknown-phone-number';
import reversePhoneLookupFreeVsPaid from './articles/reverse-phone-lookup-free-vs-paid';
import protectingYourselfPhoneScamsAustralia from './articles/protecting-yourself-phone-scams-australia';
import telemarketingLawsAustralia from './articles/telemarketing-laws-australia';
import callBlockingApps from './articles/call-blocking-apps';
import managingUnwantedCalls from './articles/managing-unwanted-calls';
import phoneScamsCommunityImpact from './articles/phone-scams-community-impact';
import reportPhoneScamAustralia from './articles/report-phone-scam-australia';
import landlineVsMobileSecurity from './articles/landline-vs-mobile-security';
import voicemailGreetingScamDeterrent from './articles/voicemail-greeting-scam-deterrent';
import futureOfCallerId from './articles/future-of-caller-id';
import passwordSecurityBasics from './articles/password-security-basics';
import passwordManagers from './articles/password-managers';
import twoFactorAuthentication from './articles/two-factor-authentication';
import afterAScamCall from './articles/after-a-scam-call';
import au from './regions/au';
import us from './regions/us';
import gb from './regions/gb';
import ca from './regions/ca';

export const articles = [
  commonPhoneScams,
  redFlags,
  whatNotToDo,
  verifyBeforeYouTrust,
  callerIdSpoofing,
  smishing,
  understandingCallerIdAustralia,
  traceUnknownPhoneNumber,
  reversePhoneLookupFreeVsPaid,
  protectingYourselfPhoneScamsAustralia,
  telemarketingLawsAustralia,
  callBlockingApps,
  managingUnwantedCalls,
  phoneScamsCommunityImpact,
  reportPhoneScamAustralia,
  landlineVsMobileSecurity,
  voicemailGreetingScamDeterrent,
  futureOfCallerId,
  passwordSecurityBasics,
  passwordManagers,
  twoFactorAuthentication,
  afterAScamCall,
];

export const regions = [au, us, gb, ca];

export const CATEGORY_LABELS = {
  scams: 'Scam awareness',
  guides: 'Guides & resources',
  digital: 'Digital security',
};

export const GUIDE_TYPE_LABELS = {
  overview: 'Overview',
  guide: 'Guide',
  comparison: 'Comparison',
  tips: 'Tips',
};

export function getArticleBySlug(slug) {
  return articles.find((a) => a.slug === slug) || null;
}

export function getRegionByCode(code) {
  const normalized = (code || '').toLowerCase();
  return regions.find((r) => r.code === normalized) || null;
}

export function getArticlesByCategory(category) {
  return articles.filter((a) => a.category === category);
}

export function getAllArticlePaths() {
  return articles.map((a) => `/learn/${a.slug}`);
}

export function getLearnManifest() {
  return {
    hub: {
      title: 'Phone safety guides & articles | WhoDatNumber',
      description:
        'Expert guides on unknown callers, phone scams in Australia, caller ID, reverse lookup, and protecting your accounts.',
      path: '/learn',
    },
    articles: articles.map((a) => ({
      slug: a.slug,
      title: `${a.title} | WhoDatNumber`,
      description: a.description,
      path: `/learn/${a.slug}`,
    })),
    regions: {
      index: {
        title: 'Report scams by country | WhoDatNumber',
        description:
          'Official fraud and scam reporting links for Australia, United States, United Kingdom, and Canada.',
        path: '/learn/regions',
      },
      items: regions.map((r) => ({
        code: r.code,
        title: `Report scams in ${r.name} | WhoDatNumber`,
        description: `Where to report phone and online scams in ${r.name}, plus local tips.`,
        path: `/learn/regions/${r.code}`,
      })),
    },
  };
}

